var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154.03 160.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:white;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,124.2c0-22.19,8.12-36,14.57-46.61,6.26-10.32,12.84-23.75,13.09-43,.22-18.45-11-33.4-12-34.6C32.7,1.83,0,37,0,80.11c0,43.73,33.65,79.29,75.49,80.17C69.87,159,58,146.3,58,124.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.34,132.71c-1.68,0-3.39.1-5.19.21A96.31,96.31,0,0,0,74.34,157Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.34,106.39c-.67,0-1.33,0-2,0a86.41,86.41,0,0,0-3.21,18.16c-.07,1-.11,1.9-.11,2.87,1.76-.13,3.54-.22,5.32-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.24,20.91a82.66,82.66,0,0,0,10.38-4.09C112.65,9.49,96,2,84.09.12,92.66,4.73,105.79,13.56,112.24,20.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.48,136.29A95.66,95.66,0,0,0,95,134.06c-3,6.49-7.48,17.85-12.4,23.78C93.28,151.82,100.48,143.23,106.48,136.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86,159.41c15-1.24,30.49-11.4,36.57-17.47a86.78,86.78,0,0,0-10.35-4.11C105.84,145.22,94.61,154.78,86,159.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116,133.39a90.39,90.39,0,0,1,11.49,4.74,75.58,75.58,0,0,0,16.48-20.23,111.13,111.13,0,0,0-16.12-5.47A88.2,88.2,0,0,1,116,133.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.82,132.71l-1,24.36c3.06-3,8.85-17.68,10.3-23.81C85.82,132.94,82.76,132.77,79.82,132.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.89,76.73H154a78.62,78.62,0,0,0-7.67-31,117.38,117.38,0,0,1-16.78,5.77A87.66,87.66,0,0,1,133.89,76.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.58,107.4a124,124,0,0,1,16.78,5.76,78.39,78.39,0,0,0,7.67-31H133.89A87.46,87.46,0,0,1,129.58,107.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.78,46.24a129.79,129.79,0,0,0,16.11-5.42A82.76,82.76,0,0,0,127.4,20.61,82.43,82.43,0,0,1,116,25.37,88.66,88.66,0,0,1,127.78,46.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.82,127.26a109.7,109.7,0,0,1,11.64.84,137.77,137.77,0,0,0,6.88-20.74c-5.68-.58-11.9-.93-18.52-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.06,76.73h16a123.08,123.08,0,0,0-2.33-19.84c-1.87.19-3.82.36-5.79.51A91.9,91.9,0,0,1,86.06,76.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.21,47.5a84,84,0,0,0-11.94-20.4,87.53,87.53,0,0,1-13.22,3,139.67,139.67,0,0,1,6.77,20.68A165.74,165.74,0,0,0,122.21,47.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.2,52.73A175.44,175.44,0,0,1,105,56.14a116.09,116.09,0,0,1,2.4,20.59h21A80.9,80.9,0,0,0,124.2,52.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.21,111.19A165.65,165.65,0,0,0,103.82,108,142.59,142.59,0,0,1,97,128.85a119.47,119.47,0,0,1,13.24,2.81A85,85,0,0,0,122.21,111.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.82,88.05V101c6,.06,12.37.41,19.85,1.07A121.11,121.11,0,0,0,102,82.16H83C81.88,84.17,80.81,86.14,79.82,88.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.48,22.58C100.05,15.81,88.54,5.44,80.34,1.37,85.5,8.42,91.59,14.35,94.78,25,99.32,24.23,103.07,23.46,106.48,22.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.4,82.16H107.55a118.1,118.1,0,0,1-2.4,20.59,190.46,190.46,0,0,1,19.2,3.38A85.8,85.8,0,0,0,128.4,82.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.12,51.92c1-.07,2.12-.15,3.22-.26-.69-2.83-1.44-5.57-2.27-8.25A58.47,58.47,0,0,1,95.12,51.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyLogo);
export default __webpack_public_path__ + "static/media/Only_Logo.99d1ed8c6ce569f3b021c047afbd05c3.svg";
export { ForwardRef as ReactComponent };